import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `AccountsControllerStateProvider` not mounted on RN.
export default function useAccountsControllerState(): any {
  const { state } = useController('AccountsController' as any)
  return state as any
}
